var data = [{
  txt: 'Create',
  items: [{
    bgColor: 0,
    title: 'Design library',
    desc: 'Start creating instantly with our ready-made design resources.',
    items: [{
      title: 'Templates',
      cols: [{
        title: 'By use case',
        items: [{
          href: '/templates/social-media',
          txt: 'Social media'
        }, {
          href: '/templates/search?q=ads',
          txt: 'Ads & promos'
        }, {
          href: '/templates/flyers',
          txt: 'Flyers'
        }, {
          href: '/templates/logos',
          txt: 'Logos'
        }, {
          href: '/templates/videos',
          txt: 'Videos'
        }]
      }, {
        title: 'By platform',
        items: [{
          href: '/templates/instagram',
          txt: 'Instagram'
        }, {
          href: '/templates/youtube',
          txt: 'Youtube'
        }, {
          href: '/templates/facebook',
          txt: 'Facebook'
        }, {
          href: '/templates/etsy-shop-covers',
          txt: 'Etsy'
        }, {
          href: '/templates/pinterest-pins',
          txt: 'Pintrest'
        }]
      }],
      more: {
        href: '/templates',
        txt: 'See all templates'
      }
    }, {
      title: 'Assets',
      cols: [{
        items: [{
          href: '/colors/',
          txt: 'Colors'
        }, {
          href: 'https://tools.picsart.com/text/font-generator/',
          txt: 'Fonts'
        }, {
          href: '/stickers',
          txt: 'Stickers'
        }, {
          href: '/images/backgrounds',
          txt: 'Backgrounds'
        }, {
          href: '/images',
          txt: 'Images'
        }]
      }]
    }]
  }, {
    bgColor: 1,
    title: 'Tools',
    desc: 'Explore the full suite of AI tools for photo, video, and design.',
    items: [{
      title: 'Photo Editor',
      cols: [{
        items: [{
          href: '/background-changer/',
          txt: 'Background Changer'
        }, {
          href: '/background-remover/',
          txt: 'Background Remover'
        }, {
          href: '/collage-maker/',
          txt: 'Collage Maker'
        }, {
          href: '/photo-effects/photo-to-cartoon/',
          txt: 'Photo to Cartoon'
        }, {
          href: '/resize-image/',
          txt: 'Image Resizer'
        }, {
          href: '/photo-effects/',
          txt: 'Photo Filters'
        }]
      }, {
        items: [{
          href: '/flip-image/',
          txt: 'Flip Image'
        }, {
          href: '/remove-object-from-photo/cleanup-pictures/',
          txt: 'Cleanup Pictures'
        }, {
          href: '/sticker-maker/',
          txt: 'Sticker Maker'
        }, {
          href: '/remove-object-from-photo/',
          txt: 'Remove Object from Photo'
        }, {
          href: '/crop-image/',
          txt: 'Crop Image'
        }, {
          href: '/ai-image-enhancer/sharpen-image/',
          txt: 'Image Sharpener'
        }]
      }],
      more: {
        href: '/photo-editing-tools/',
        txt: 'See all image tools'
      },
      titleHref: '/photo-editor/'
    }, {
      title: 'Ai Editor',
      cols: [{
        items: [{
          href: '/ai-image-generator/',
          txt: 'AI Image Generator'
        }, {
          href: '/ai-image-enhancer/',
          txt: 'AI Image Enhancer'
        }, {
          href: '/ai-background/',
          txt: 'AI Background '
        }, {
          href: '/ai-replace/',
          txt: 'AI Replace'
        }, {
          href: '/ai-gif-generator/',
          txt: 'AI GIF Generator'
        }, {
          href: '/ai-logo-generator/',
          txt: 'AI Logo Maker'
        }]
      }],
      more: {
        href: '/ai-design-tools/',
        txt: 'See all AI tools'
      },
      titleHref: '/ai-photo-editor/'
    }, {
      title: 'Other',
      cols: [{
        items: [{
          href: '/colors/color-picker/',
          txt: 'Color Picker'
        }, {
          href: '/colors/color-wheel/',
          txt: 'Color Wheel'
        }, {
          href: '/video-editing-tools/',
          txt: 'Video Editor'
        }, {
          href: '/text-editor/',
          txt: 'Text Editor'
        }, {
          href: '/batch-photo-editor/',
          txt: 'Batch Editor'
        }, {
          href: 'https://tools.picsart.com/text/font-generator/',
          txt: 'Font Generator'
        }]
      }]
    }],
    btn: {
      buttonType: 2,
      href: '/create/editor',
      txt: 'Launch Editor'
    }
  }],
  cat: 0
}, {
  txt: 'For Businesses',
  items: [{
    bgColor: 1,
    desc: 'Accelerate your business with Picsart. Find out how.',
    items: [{
      title: 'Use cases',
      titleSize: 6,
      cols: [{
        items: [{
          txt: 'Web to print',
          href: 'https://picsart.io/create-sdk-for-print/'
        }, {
          txt: 'Photo printing',
          href: 'https://picsart.io/create-sdk-for-photos/'
        }, {
          txt: 'Social media',
          href: 'https://picsart.io/create-editor-for-social-media/'
        }, {
          txt: 'E-commerce',
          href: 'https://picsart.io/remove-background-api-product-photos/'
        }]
      }]
    }, {
      title: 'SDK/API',
      titleSize: 6,
      cols: [{
        items: [{
          txt: 'Print Editor SDK',
          href: 'https://picsart.io/create-sdk-for-print/'
        }, {
          txt: 'Upscaler API',
          href: 'https://picsart.io/ultra-upscale/automated-image-processing/'
        }, {
          txt: 'Social Media Editor SDK',
          href: 'https://picsart.io/create-editor-for-social-media/'
        }, {
          txt: 'Background Remover API',
          href: 'https://picsart.io/remove-background-api-product-photos/'
        }, {
          txt: 'Ultra Enhance API',
          href: 'https://picsart.io/ultra-enhance/'
        }]
      }],
      more: {
        href: 'https://picsart.io/',
        txt: 'See all SDK/API'
      }
    }]
  }, {
    bgColor: 0,
    title: 'Integrate AI Powered Content Editor to your platform.',
    titleSize: 5,
    img: {
      src: 'https://pastatic.picsart.com/cms-pastatic/ceae49f9-22c3-485e-873c-f1fade33eafa.png?type=webp&to=min&r=192&q=100',
      alt: 'Business Picture'
    },
    more: {
      txt: 'Learn more',
      href: 'https://picsart.io/'
    },
    href: 'https://picsart.io/'
  }],
  cat: 1
}, {
  txt: 'Learn & Connect',
  items: [{
    bgColor: 1,
    title: 'Learn',
    desc: 'Discover inspiration to grow your business.',
    items: [{
      title: 'Blog',
      cols: [{
        items: [{
          txt: 'Trends',
          href: '/blog/category/trends'
        }, {
          txt: 'Community',
          href: '/blog/category/community'
        }, {
          txt: 'Ads',
          href: '/blog/category/ads'
        }, {
          txt: 'Design School',
          href: '/blog/category/design-school'
        }, {
          txt: 'Inspirational',
          href: '/blog/category/inspiration'
        }]
      }],
      more: {
        txt: 'See all articles',
        href: '/blog'
      }
    }, {
      title: 'Latest news',
      desc: 'Stay up-to-date with the latest news from Picsart.',
      more: {
        href: '/blog/category/news',
        txt: 'Learn more'
      }
    }, 'horizontal-line', {
      title: 'Tutorials',
      desc: 'Learn how to bring your creative vision to life.',
      more: {
        href: '/blog/category/how-tos',
        txt: 'Learn more'
      }
    }]
  }, {
    bgColor: 0,
    title: 'Connect',
    desc: 'Connect with creators who share your interests.',
    img: {
      src: 'https://pastatic.picsart.com/cms-pastatic/dbaf75f4-ab12-4208-bc7a-295dd8fe6780.png?type=webp&to=min&r=248&q=100',
      alt: 'Connect Picture'
    },
    items: [{
      title: 'Spaces',
      cols: [{
        items: [{
          txt: 'The Creator Club',
          href: '/spaces/the-creator-club'
        }, {
          txt: 'AI Portraits',
          href: '/spaces/ai-portraits'
        }, {
          txt: 'AI Product Design',
          href: '/spaces/ai-product-design'
        }, {
          txt: 'Generative AI',
          href: '/spaces/generative-ai'
        }, {
          txt: 'Content Creators',
          href: '/spaces/content-creators'
        }]
      }],
      more: {
        txt: 'See all spaces',
        href: '/spaces/'
      }
    }]
  }],
  cat: 2
}, {
  txt: 'Pricing',
  href: '/pricing/'
}, {
  buttonType: 0,
  href: '/search/'
}, {
  buttonType: 1,
  href: '/create',
  txt: 'Start creating'
}];

export { data as default };
//# sourceMappingURL=index.js.map
